(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesDialogController', TabObjectTypesDialogController);

    TabObjectTypesDialogController.$inject = ['$state', '$timeout', '$scope', 'entity', 'TabDevices', 'TabFiles', 'TabObjectTypes', 'TabFileTypes'];

    function TabObjectTypesDialogController($state, $timeout, $scope, entity, TabDevices, TabFiles, TabObjectTypes, TabFileTypes) {

        var vm = this;
        vm.tabObjectTypes = entity;
        vm.tabdevices = TabDevices.query({size: 1000});
        vm.tabfiles = TabFiles.query({size: 1000});
        vm.tabFileTypes = TabFileTypes.query({size: 1000});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-object-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabObjectTypes.id !== null) {
                TabObjectTypes.update(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            } else {
                checkControl();
                TabObjectTypes.save(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            }
        };

        function checkControl() {
            if (vm.tabObjectTypes.skipBurnin === undefined || vm.tabObjectTypes.skipBurnin == null) {
                vm.tabObjectTypes.skipBurnin = false;
            }
            if (vm.tabObjectTypes.multipleDocs === undefined || vm.tabObjectTypes.multipleDocs == null) {
                vm.tabObjectTypes.multipleDocs = false;
            }
            if (vm.tabObjectTypes.greengrassType === undefined || vm.tabObjectTypes.greengrassType == null) {
                vm.tabObjectTypes.greengrassType = false;
            }
        }


        vm.saveAndContinue = function () {

            vm.isSaving = true;
            if (vm.tabObjectTypes.id == null) {
                checkControl();
                TabObjectTypes.save(vm.tabObjectTypes, andContinue, onSaveError);
            }


        };

        function andContinue(result) {
            $state.go("object-types-device-releases", {
                id: result.id
            });
        }

        vm.clear = function () {
            localStorage.removeItem('tabObjectTypes');
            $state.go('tab-object-types');
        };
    }
})();
